/**
 * Transpose ▲▼ pitch ▹ speed ▹ loop
 *
 * Audio pitch/speed tool exposing its UI pages to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 6.4.1.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ioimlbgefgadofblnajllknopjboejda';
export const transpose: ExtensionDefinition = {
  id: ID,
  name: "Transpose ▲▼ pitch ▹ speed ▹ loop",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Audio pitch/speed tool exposing its UI pages to every origin.",
  signals: [
    { id: 'war-popup-index-html', kind: 'web-accessible-resource',
      description: 'Fetch popup/index.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'popup/index.html') },
    { id: 'war-sidepanel-index-html', kind: 'web-accessible-resource',
      description: 'Fetch sidepanel/index.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'sidepanel/index.html') },
  ],
};
